import { ApiRequestModel } from "../api_request_model";
import { BaseClass } from "../master/mastermodel";

export class DownloadFileRequest extends BaseClass {
  public ActorDocPageCode: number;
  public ActorImageCode: number;
  public ActorCode: number;
  public DBFileName: string;
  public folderType: string;
  public FileExtension: string;
  public FriendlyFileName: string;
 // public SendApiRequestModel: ApiRequestModel;
}

export class DocRenewConfigRequest extends BaseClass {
 // public ConditionalOperator: number;
  public CredentialTypeCode: number;
  public DocRenewConfigCode: number;
  public AlertLevel: string;
  public AlertBeforeDays: number;
  public MessageTo: string;
  public MessageText: string;
  public RecordStatus: string;
  public CredentialTypeGroup: string;
 // public SendApiRequestModel: ApiRequestModel;
}
export class DocRenewConfigInfoController {
  public DocRenewConfigCode: number;
  public CredentialTypeCode: number;
  public AlertLevel: string;
  public AlertLevelLongValue: string;
  public AlertBeforeDays: number;
  public MessageTo: string;
  public MessageToLongValue: string;
  public MessageText: string;
  public CredentialTypeName: string;
  public CredentialTypeShortName: string;
  public CredentialTypeGroup: string;
  public CredentialTypeSpeciality: string;
  public CredentialTypeRenewalType: string;
  public CredentialRenewalTypeLongValue: string;
  public RenewalDurationDays: number;
}

export class ActorDocRenewAlertsRequest extends BaseClass {
  public ActorCode: number;
 // public SendApiRequestModel: ApiRequestModel;
}
export class ActorDocRenewAlertsInfoController{
  public ActorCode: number;
  public ActorCredentialCode: number;
  public CredentialTypeCode: number;
  public DocRenewConfigCode: number;
  public CredentialTypeName: string;
  public GroupOrFolder: string;
  public RenewalType: string;
  public AlertLevel: string;
  public AlertBeforeDays: number;
  public MessageTo: string;
  public MessageText: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public AdditionalDetail: string;
  public ActorDocCode: number;
  public Remarks: string;
  public AlertBeforeOn: Date;
  public DocRenewMessage: string;
}


export class InitiateActorDocVerificationRequest extends BaseClass {
  public OwnerFacilityActorCode: number;
  public InitiatedByActorCode: number;
  public InitiatedBy: string;
  public NurseActorCode: number;
  public ActorDocCode: number;
}


export class ActorDocVerTrackInfoByDocCodeRequest extends BaseClass {
  public FacilityActorCode: number;
  public ActorDocCode: number;
}



export class ActorDocVerTrackInfoByDocCodeController {
  public DocType: string;
  public InitiatedBy: string;
  public VerStatus: string;
  public FirstPartyRemarks: string;
  public SecondPartyRemarks: string;
  public AssignedTo: string;
  public OwnerFacilityActorCode: number;
  public OnDate: Date;
  public DocumentDetails: string;
  public VerifiedBy: string;
}

export class ActorDocVerTrackRequest extends BaseClass {
  public ActorCode: number;
  public ActorDocCode: number;
  public ActorDocVerCode: number;
  public CredentialTypeCode: number;
  public DocumentDetails: string;
  public VerStatus: string;
  public FirstPartyRemarks: string;
  public SecondPartyRemarks: string;
  public AssignedByActorCode: number;
  public AssignedBy: string;
  public AssignedToActorCode: number;
  public AssignedTo: string;
  public VerifiedByActorCode: number;
  public VerifiedBy: string;
}
